import { render, staticRenderFns } from "./SurfacePostAttachment.vue?vue&type=template&id=5e63e134&"
import script from "./SurfacePostAttachment.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports